import React, { useContext } from "react";

//Components
import NavbarComponent from "../../components/NavbarComponent/NavbarComponent";
import SideMenusComponent from "../../components/SideMenusComponent/SideMenusComponent";
import LoadingScreenComponent from "../../components/LoadingScreenComponent/LoadingScreenComponent";
import NavbarMobile from "../../components/NavbarMobile/NavbarMobile";
import NavbarMobileBottom from "../../components/NavbarMobileBotton/NavbarMobileBottom";
import VersionTxtComponent from "../../components/VersionTxtComponent/VersionTxtComponent";
import MoreInfoDataFormRenovationBody from "../../components/MoreInfoDataFormRenovationBody/MoreInfoDataFormRenovationBody";

//Context
import { LoadingContext } from "../../context/LoadingContext";

const MoreInfoDataRenovationScreen = ({ userData, userMenuData }) => {
  const { loading } = useContext(LoadingContext);

  return (
    <>
      {loading && <LoadingScreenComponent />}
      <div className="body-container">
        <VersionTxtComponent />
        <div className="body-subcontainer">
          <NavbarComponent userData={userData} />
          <NavbarMobile userData={userData} menuData={userMenuData} />
          <MoreInfoDataFormRenovationBody />
          <NavbarMobileBottom />
        </div>
        <SideMenusComponent menuData={userMenuData} />
      </div>
    </>
  );
};

export default MoreInfoDataRenovationScreen;
